import { MASS_ACTIONS } from 'constants/actionTypes';

const initialState = {
  requestingShared: false,
  shared: [],
  updatedShared: [],
};

const massActionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case MASS_ACTIONS.SHARED.REQUEST:
      return {
        ...state,
        requestingShared: true,
      };

    case MASS_ACTIONS.SHARED.REQUEST_SUCCESS:
      return {
        ...state,
        requestingShared: false,
        shared: action.shared,
      };

    case MASS_ACTIONS.SHARED.UPDATED:
      return {
        ...state,
        updatedShared: action.updatedShared,
      };

    case MASS_ACTIONS.SHARED.REMOVE_ALL:
      return {
        ...state,
        shared: [],
        updatedShared: [],
      };

    default:
      return state;
  }
};

export default massActionsReducer;
